var CompanySize = {
	"Company size": "公司規模",
	"1-19 employees": "1-19 名員工",
	"20-99 employees": "20-99 名員工",
	"100-499 employees": "100-499 名員工",
	"500-999 employees": "500-999 名員工",
	"1,000-9,999 employees": "1,000-9,999 名員工",
	"10,000 employees or more": "10,000 名員工以上"
};

export { CompanySize as default };
